import PostStructure from "../../Constants/PostStructure";

const fetchPostData = async () => {
  try {
    const response = await fetch("/api/mock/AccountPage/UserAccountPostContentMockapi.json");
    const data = await response.json();
    
    // Validate data before returning
    return data.map((userPost) => ({
      ...PostStructure,
      ...userPost,
      posts: userPost.posts.map((post) => ({
        ...PostStructure.posts[0], // Default structure
        ...post,
        medias: post.medias.map((media) => ({
          ...PostStructure.posts[0].medias[0],
          ...media,
        })),
        likes: post.likes ?? [],
        comments: post.comments ?? [],
        shares: post.shares ?? [],
        suggests: post.suggests ?? [],
      })),
    }));
  } catch (error) {
    console.error("Error fetching post data:", error);
    return [];
  }
};

export default fetchPostData